import application from 'application/application';

const controller = 'DefaultMovementsInssManagerController';

application.controller(controller, [
	'$scope',
	'$rootScope',
	'$http',
	'$state',
	'$stateParams',
	'API',
	'helper',
	'notification',
	'permissions',
	'$location',
	(
		$scope,
		$rootScope,
		$http,
		$state,
		$stateParams,
		API,
		helper,
		notification,
		permissions,
		$location
	) => {
		$scope.accessRecords = {
			isReady: false,
			items: []
		};

		$scope.inputTypePassword = 'password';

		$scope.modalAccountData = {
			login: '',
			password: '',
			qrCode: '',
			select: ''
		};

		$scope.quantityPerPage = 10;

		$scope.registerINSSAccountData = {};
		$scope.modalRegisterINSSAccountSuccess = false;

		$scope.systemsDropdownItems = [];

		$scope.showRegisterFields = {
			login: 'disabled',
			password: 'disabled',
			qrCode: 'hidden'
		};

		$scope.accessInAction = null;

		$scope.isMobile = false;

		$scope.dontShowAgainCheckbox = false;

		$scope.registerLoginErrorMessage = '';
		$scope.registerQrCodeErrorMessage = '';

		$scope.isRegisterPasswordValid = true;

		$scope.groupData = JSON.parse(localStorage.getItem('__groupUserData__'));
		$scope.groupUserSelected = JSON.parse(
			localStorage.getItem('__groupSelected__')
		);

		$scope.geridId = null;
		$scope.geridAccess = [];
		$scope.isChangingGerid = false;
		$scope.isRegisteringGerid = false;
		$scope.showRegisterGeridSuccess = false;

		$scope.registerAccess = JSON.parse(
			localStorage.getItem('__registerAccess__') || 'false'
		);
		$scope.createAccess = JSON.parse(
			localStorage.getItem('__createAccess__') || 'false'
		);
		$scope.accessRecords = JSON.parse(
			localStorage.getItem('__accessRecords__') || 'false'
		);

		$scope.findGeridId = () => {
			if (API.default.hostname.includes('homologacao-')) {
				$scope.geridId = 425;
			} else if (
				API.default.hostname.includes('dev-') ||
				API.default.hostname.includes('localhost')
			) {
				$scope.geridId = 425;
			} else {
				$scope.geridId = 480;
			}
		};

		$scope.findGeridId();

		$scope.fetchAccounts = () => {
			$scope.isMobile =
				window && window.innerWidth && window.innerWidth <= 991 ? true : false;

			const userParamsSession = sessionStorage.getItem('parametros-usuarios');

			let dataParameterUsers = null;

			if (
				userParamsSession &&
				userParamsSession != undefined &&
				userParamsSession != 'undefined'
			) {
				dataParameterUsers = JSON.parse(userParamsSession);
			}

			let record = dataParameterUsers || null;

			if (record) {
				$scope.quantityPerPage = record.qtdRegistroPorPaginaInssGerenciador
					? record.qtdRegistroPorPaginaInssGerenciador
					: 10;
			}

			let paginaAtual = 1;

			const urlParams = $location.$$url.split('?')[1];

			if (urlParams) {
				const pages = urlParams.split('&');

				pages.forEach(page => {
					const parameter = page.split('=');

					if (parameter[0] && parameter[1] && parameter[0] == 'paginaAtual') {
						paginaAtual = parameter[1];
					}
				});
			}

			const paramsSearch = {
				paginaAtual,
				registrosPorPagina: $scope.quantityPerPage,
				idGrupoUsuarios:
					$scope.groupUserSelected && $scope.groupData
						? $scope.groupData.idGrupo
						: null
			};

			$http({
				...helper.http(API.sourceAccessData, 'GET'),
				method: 'GET',
				params: paramsSearch
			})
				.then(response => {
					if (
						response.data &&
						response.data.itens &&
						response.data.itens.length > 0
					) {
						$scope.accessRecords = {
							items: response.data.itens
						};
					}
					$scope.paginacao = response.data.paginacao;
					$scope.isLoadingAccessData = false;
				})
				.finally(() => {
					$scope.accessRecords = {
						...$scope.accessRecords,
						isReady: true
					};
				});

			if ($scope.geridAccess.length == 0) {
				$scope.fetchGeridAccess();
			}
		};

		$scope.fetchGeridAccess = () => {
			$scope.geridAccess = [];
			const paramsSearch = {
				paginaAtual: 1,
				registrosPorPagina: 100,
				idGrupoUsuarios:
					$scope.groupUserSelected && $scope.groupData
						? $scope.groupData.idGrupo
						: null,
				idFonteXTipoPesquisa: $scope.geridId
			};

			$http({
				...helper.http(API.sourceAccessData, 'GET'),
				method: 'GET',
				params: paramsSearch
			}).then(response => {
				if (
					response.data &&
					response.data.itens &&
					response.data.itens.length > 0
				) {
					for (let item in response.data.itens) {
						$scope.geridAccess.push(response.data.itens[item]);
					}
				}
			});
		};

		$scope.openUrl = url => {
			window.open(url, '_blank');
		};

		$scope.updateQuantityPerPage = quantityPerPage => {
			const userParamsSession = sessionStorage.getItem('parametros-usuarios');

			let dataParameterUsers = null;

			if (
				userParamsSession &&
				userParamsSession != undefined &&
				userParamsSession != 'undefined'
			) {
				dataParameterUsers = JSON.parse(userParamsSession);
			}

			let record = dataParameterUsers;

			$scope.quantityPerPage = quantityPerPage;

			sessionStorage.setItem('__pageMovementsInss__', 1);
			record.qtdRegistroPorPaginaInssGerenciador = quantityPerPage || 10;

			sessionStorage.setItem('parametros-usuarios', JSON.stringify(record));

			let filters = {};

			queryConvert().map(filter => (filters[filter.key] = filter.value));

			$scope.idQtdItensPagina = $scope.idQtdItensPagina
				? $scope.idQtdItensPagina
				: record.idParamUsuarioProdAdv;

			if (
				$location &&
				$location.search() &&
				$location.search().paginaAtual != 1
			) {
				$location.search({ paginaAtual: 1 });
			} else {
				$location.search({});
			}

			$scope.fetchAccounts();
		};

		$scope.hasMovementsPrevPage = () => {
			return $scope.paginacao.paginaAtual > 1 ? true : false;
		};

		$scope.hasMovementsNextPage = () => {
			return $scope.paginacao.paginaAtual < $scope.paginacao.paginaTotal
				? true
				: false;
		};

		$scope.changePage = direction => {
			let newPage = 1;
			let params = {};

			switch (direction) {
				case 'first':
					newPage = 1;
					break;
				case 'prev':
					newPage = $scope.paginacao.paginaAtual - 1;
					break;
				case 'next':
					newPage = $scope.paginacao.paginaAtual + 1;
					break;
				case 'last':
					newPage = $scope.paginacao.paginaTotal;
					break;
			}

			if (newPage != 1) {
				params = { paginaAtual: newPage };
			}

			$state.go($state.current.name, params, {
				inherit: false,
				reload: 'root.default.inssManager'
			});
		};

		$scope.deleteAccess = access => {
			$scope.loadingDeleteAccess = true;

			if (access) {
				$http({
					...helper.http(API.sourceAccessData, 'DELETE'),
					method: 'PUT',
					data: {
						idPesqAcessoFonteUsCliente: access.idPesqAcessoFonteUsCliente,
						idGrupoUsuarios:
							$scope.groupUserSelected && $scope.groupData
								? $scope.groupData.idGrupo
								: null
					},
					messageOverride: {
						success(response, notify) {
							notify.success('Acesso apagado com sucesso.');
						}
					}
				})
					.then(() => {})
					.finally(() => {
						$scope.loadingDeleteAccess = false;
						$scope.accessInAction = null;
						$scope.fetchAccounts();
						$scope.fetchGeridAccess();
						$scope.closeModal('#modalDeleteAccess');

						if (
							$scope.paginacao.registrosTotal %
								$scope.paginacao.registrosPorPagina ==
							1
						) {
							if ($scope.paginacao.paginaAtual > 1) {
								$scope.changePage('prev');
							} else {
								$scope.changePage('first');
							}
						}
					});
			} else {
				notification.alert(
					'Houve um problema ao excluir. Tente novamente, por favor.'
				);
				$scope.loadingDeleteAccess = false;
				$scope.accessInAction = null;
				$scope.closeModal('#modalDeleteAccess');
			}

			if ($scope.accessRecords.items.length <= 1) {
				localStorage.setItem('__registerAccess__', JSON.stringify(false));
				localStorage.setItem('__createAccess__', JSON.stringify(false));
			}

			localStorage.setItem(
				'__accessRecords__',
				JSON.stringify(!($scope.accessRecords.items.length === 1))
			);

			$scope.registerAccess = JSON.parse(
				localStorage.getItem('__registerAccess__') || 'false'
			);
			$scope.createAccess = JSON.parse(
				localStorage.getItem('__createAccess__') || 'false'
			);
			$scope.accessRecords = JSON.parse(
				localStorage.getItem('__accessRecords__') || 'false'
			);
		};

		$scope.updateAccessStatus = (access, newValue) => {
			return { access, newValue };
		};

		$scope.changeRegisterSystem = system => {
			if ($scope.geridId == system.idFonteXTipoPesquisa) {
				$scope.isChangingGerid = true;
			} else {
				$scope.isChangingGerid = false;
			}

			let newRegisterFields = {
				login: 'disabled',
				password: 'disabled',
				qrCode: 'hidden'
			};

			if (
				system &&
				system.tipoAcessoFontePesquisas &&
				system.tipoAcessoFontePesquisas[0]
			) {
				system.tipoAcessoFontePesquisas.forEach(id => {
					switch (id.idTipoAcessoFontePesq) {
						case -1:
							newRegisterFields = {
								...newRegisterFields,
								login: 'show',
								password: 'show'
							};
							break;
						case -2:
							newRegisterFields = {
								...newRegisterFields,
								qrCode: 'show'
							};
							break;
					}
				});
			}
			$scope.showRegisterFields = newRegisterFields;

			setTimeout(() => {
				if (!$scope.isMobile) {
					const inputElement = document.getElementById('inputLoginText');

					if (inputElement) {
						inputElement.focus();
					}
				} else {
					const inputElement = document.getElementById('inputLoginTextMobile');

					if (inputElement) {
						inputElement.focus();
					}
				}
			}, 100);
		};

		$scope.onCPFInputChange = () => {
			$scope.registerLoginErrorMessage = '';

			if (
				$scope.registerINSSAccountData &&
				$scope.registerINSSAccountData.login &&
				$scope.registerINSSAccountData.login.length - 3 == 11
			) {
				let isCPFValid = helper.validateCPF(
					$scope.registerINSSAccountData.login
				);

				if (!isCPFValid) {
					$scope.registerLoginErrorMessage = 'CPF inválido.';
				} else {
					const inputElement = document.getElementById('inputPassword');

					if (inputElement) {
						inputElement.focus();
					}
				}
			}
		};

		$scope.onPasswordInputChange = () => {
			$scope.isRegisterPasswordValid = true;
		};

		$scope.onCpfInputBlur = () => {
			if (
				$scope.registerINSSAccountData &&
				$scope.registerINSSAccountData.login &&
				$scope.registerINSSAccountData.login.length > 0
			) {
				let isCPFValid = helper.validateCPF(
					$scope.registerINSSAccountData.login
				);

				if (!isCPFValid) {
					$scope.registerLoginErrorMessage = 'CPF inválido.';
				}
			} else {
				$scope.registerLoginErrorMessage = 'Campo obrigatório.';
			}
		};

		$scope.onPasswordBlur = () => {
			const isPasswordValid =
				$scope.registerINSSAccountData &&
				$scope.registerINSSAccountData.password &&
				$scope.registerINSSAccountData.password.length > 0;

			if (!isPasswordValid) {
				$scope.isRegisterPasswordValid = false;
			}
		};

		$scope.registerINSSAccount = data => {
			let hasError = false;

			if (
				!(
					data.login &&
					data.password &&
					$scope.showRegisterFields.qrCode == 'hidden'
				) &&
				!(data.login && data.password && data.qr_code)
			) {
				hasError = true;
			}

			if (!(data.login && data.login.length > 0)) {
				$scope.registerLoginErrorMessage = 'Campo obrigatório.';
				hasError = true;
			}

			const isCPFValid = helper.validateCPF(data.login);

			const isPasswordValid = data.password.length > 0;

			if (!isCPFValid && data.login.length > 0) {
				hasError = true;
				$scope.registerLoginErrorMessage = 'CPF inválido.';

				setTimeout(() => {
					if (!$scope.isMobile) {
						const inputElement = document.getElementById('inputLoginText');

						if (inputElement) {
							inputElement.focus();
						}
					} else {
						const inputElement = document.getElementById(
							'inputLoginTextMobile'
						);

						if (inputElement) {
							inputElement.focus();
						}
					}
				}, 100);
			}

			if (!isPasswordValid) {
				hasError = true;
				$scope.isRegisterPasswordValid = false;

				setTimeout(() => {
					if (!$scope.isMobile) {
						const inputElement = document.getElementById('inputPassword');

						if (inputElement) {
							inputElement.focus();
						}
					} else {
						const inputElement = document.getElementById('inputPasswordMobile');

						if (inputElement) {
							inputElement.focus();
						}
					}
				}, 100);
			}

			if (hasError) {
				return;
			}

			$scope.disableMail = true;

			const itens = [
				{
					idFonteXTipoPesquisa: data.select.idFonteXTipoPesquisa,
					dadoAcesso: data.login,
					senha: data.password,
					idGrupoUsuarios:
						$scope.groupUserSelected && $scope.groupData
							? $scope.groupData.idGrupo
							: null
				}
			];

			if ($scope.geridId == itens[0].idFonteXTipoPesquisa) {
				$scope.isRegisteringGerid = true;
			} else {
				$scope.isRegisteringGerid = false;
				$scope.showRegisterGeridSuccess = false;
			}

			if (data.qr_code && $scope.showRegisterFields.qrCode != 'hidden') {
				itens[0].autenticacao = data.qr_code;
			}

			$http({
				...helper.http(API.sourceAccessData, 'POST'),
				method: 'POST',
				data: {
					itens
				},
				messageOverride: {
					error() {}
				}
			})
				.then(() => {
					if ($scope.geridId == itens[0].idFonteXTipoPesquisa) {
						$scope.fetchGeridAccess();
						$scope.showRegisterGeridSuccess = true;
					}

					localStorage.setItem('__registerAccess__', JSON.stringify(true));
					localStorage.setItem('__createAccess__', JSON.stringify(true));
					localStorage.setItem('__accessRecords__', JSON.stringify(true));

					$scope.registerAccess = JSON.parse(
						localStorage.getItem('__registerAccess__') || 'false'
					);
					$scope.createAccess = JSON.parse(
						localStorage.getItem('__createAccess__') || 'false'
					);
					$scope.accessRecords = JSON.parse(
						localStorage.getItem('__accessRecords__') || 'false'
					);

					$scope.modalRegisterINSSAccountSuccess = true;

					setTimeout(() => {
						if ($scope.geridId == itens[0].idFonteXTipoPesquisa) {
							$scope.isRegisteringGerid = true;
						} else {
							$scope.isRegisteringGerid = false;
							$scope.showRegisterGeridSuccess = false;
						}
						$scope.disableMail = false;

						let dontShowSuccessRegisterModalAgain = localStorage.getItem(
							'__dontShowSuccessRegisterModalAgain__'
						);

						if (
							dontShowSuccessRegisterModalAgain == null ||
							dontShowSuccessRegisterModalAgain == undefined ||
							dontShowSuccessRegisterModalAgain == false ||
							dontShowSuccessRegisterModalAgain == 'false' ||
							$scope.geridId == itens[0].idFonteXTipoPesquisa
						) {
							$scope.modalRegisterINSSAccountSuccess = true;
						} else {
							$scope.closeModal('#modalRegisterINSSAccount');
						}

						$scope.fetchAccounts();

						if ($scope.$$phase !== '$apply' && $scope.$$phase !== '$digest') {
							$scope.$apply();
						}
					}, 100);
				})
				.catch(error => {
					if (
						error.data &&
						error.data.status &&
						error.data.status.erros &&
						error.data.status.erros[0]
					) {
						let errorMessage = error.data.status.erros[0].mensagem;

						if (errorMessage.contains('Erro ao cadastrar dados de acesso. ')) {
							errorMessage = errorMessage.split(
								'Erro ao cadastrar dados de acesso. '
							)[1];
						}

						$scope.registerQrCodeErrorMessage = errorMessage;
					}
				})
				.finally(() => {
					$scope.disableMail = false;
					$scope.isRegisteringGerid = false;
				});
		};

		$scope.resetQRCodeErrorMessage = () => {
			$scope.registerQrCodeErrorMessage = '';
		};

		$scope.updateINSSAccount = data => {
			//Integrar a atualização da conta INSS

			$scope.disableMail = true;
			let body = {
				idAcessoFonteCliente: data.idDadoAcessoFonte,
				atualizarSenha: false,
				atualizarAutenticacao: false,
				idGrupoUsuarios:
					$scope.groupUserSelected && $scope.groupData
						? $scope.groupData.idGrupo
						: null
			};

			if (data.password) {
				body.atualizarSenha = true;
				body.senha = data.password;
			}

			if (data.qr_code) {
				body.atualizarAutenticacao = true;
				body.autenticacao = data.qr_code;
			}

			$http({
				...helper.http(API.sourceAccessData, 'PUT'),
				method: 'PUT',
				data: body,
				messageOverride: {
					error() {}
				}
			})
				.then(() => {
					$scope.closeModal('#modalEditAccess');
					$scope.fetchAccounts();
				})
				.catch(error => {
					if (
						error.data &&
						error.data.status &&
						error.data.status.erros &&
						error.data.status.erros[0]
					) {
						let errorMessage = error.data.status.erros[0].mensagem;

						if (errorMessage.contains('Erro ao cadastrar dados de acesso. ')) {
							errorMessage = errorMessage.split(
								'Erro ao cadastrar dados de acesso. '
							)[1];
						}

						$scope.registerQrCodeErrorMessage = errorMessage;
					}
				})
				.finally(() => {
					$scope.disableMail = false;
					$scope.isRegisteringGerid = false;
				});
		};

		$scope.closeModal = id => {
			$(id).modal('hide');
		};

		$scope.openGenericModal = (access, id) => {
			$scope.isChangingGerid = false;
			$scope.isRegisteringGerid = false;
			$scope.showRegisterGeridSuccess = false;

			if (id == '#modalRegisterINSSAccount') {
				if ($scope.systemsDropdownItems.length == 0) {
					$scope.fetchSearchSources();
				}

				$scope.modalRegisterINSSAccountSuccess = false;
				$scope.registerINSSAccountData = {};
				$scope.showRegisterFields = {
					login: 'disabled',
					password: 'disabled',
					qrCode: 'hidden'
				};

				$scope.registerLoginErrorMessage = '';
				$scope.registerQrCodeErrorMessage = '';

				$scope.isRegisterPasswordValid = true;
			}

			if (id == '#modalEditAccess') {
				if ($scope.systemsDropdownItems.length == 0) {
					$scope.fetchSearchSources();
				}

				$scope.showRegisterFields = {
					login: 'disabled',
					password: 'disabled',
					qrCode: 'hidden'
				};

				$scope.registerLoginErrorMessage = '';
				$scope.registerQrCodeErrorMessage = '';

				setTimeout(() => {
					const system = $scope.systemsDropdownItems.find(
						item => item.idFonteXTipoPesquisa === access.idFonteXTipoPesquisa
					);

					$scope.changeRegisterSystem(system);
					$scope.modalAccountData = {
						idDadoAcessoFonte: access.idDadoAcessoFonte,
						login: access.dadoAcesso,
						password: '',
						qrCode: '',
						select: system
					};

					$scope.$apply();
				}, 300);
			}

			if (id == '#modalDeleteAccess') {
				$scope.accessInAction = access;
			}

			setTimeout(() => {
				$(id).modal('show');
			}, 300);
		};

		$scope.fetchSystems = () => {
			const params = {
				idUF: null,
				idInstituicao: null,
				IdTipoPesquisa: -5,
				IdClassificacaoInstituicao: null,
				idGrupoUsuarios:
					$scope.groupUserSelected && $scope.groupData
						? $scope.groupData.idGrupo
						: null
			};

			$http({
				...helper.http(API.searchFontsProcess, 'GET'),
				method: 'GET',
				params: params
			}).then(response => {
				const data = response.data;

				if (data && data.status.codigo == 200) {
					$scope.systemsDropdownItems = data.itens;
				}
			});
		};

		$scope.fetchSystems();

		$scope.fetchSearchSources = () => {
			$http({
				...helper.http(API.searchFontsProcess, 'GET'),
				method: 'GET',
				params: {
					IdTipoPesquisa: -5,
					idGrupoUsuarios:
						$scope.groupUserSelected && $scope.groupData
							? $scope.groupData.idGrupo
							: null
				}
			}).then(data => {
				if (data && data.codigo == 200) {
					$scope.systemsDropdownItems = data.itens;
				}

				setTimeout(() => {
					$scope.isLoadingAccessData = false;
					$scope.$apply();
				}, 500);

				// sessionStorage.setItem('__pageMovements__', 1);
				// $scope.listingHibben = true;

				// record.qtdRegistroMovPorPagina = quantityPerPage || 20;

				// sessionStorage.setItem('parametros-usuarios', JSON.stringify(record));

				// $scope.recordMovements($scope.movements);
			});
		};

		$scope.fetchCreditPlan = () => {
			$scope.creditPlanLoading = true;

			$http({
				...helper.http(API.userClientFunctionalities, 'GET'),
				params: {
					idFuncionalidade: -32
				}
			})
				.then(response => {
					$scope.creditPlan = response.data.itens[0];

					$scope.statusPlan = response.data.status.codigo;
				})
				.finally(() => {
					$scope.creditPlanLoading = false;
				});
		};

		$scope.fetchCreditPlan();

		$scope.showPassword = () => {
			$scope.inputTypePassword =
				$scope.inputTypePassword === 'password' ? 'text' : 'password';
		};

		$scope.changeCheckboxDontShowAgain = () => {
			$scope.dontShowAgainCheckbox = !$scope.dontShowAgainCheckbox;
		};

		$scope.closeSuccessModal = () => {
			if ($scope.dontShowAgainCheckbox) {
				localStorage.setItem('__dontShowSuccessRegisterModalAgain__', true);
			} else {
				localStorage.setItem('__dontShowSuccessRegisterModalAgain__', false);
			}

			$scope.closeModal('#modalRegisterINSSAccount');
		};

		const queryConvert = () => {
			var queryStr = window.location.search,
				queryArr = queryStr.replace('?', '').split('&'),
				queryParams = [];

			for (var q = 0, qArrLength = queryArr.length; q < qArrLength; q++) {
				var qArr = queryArr[q].split('='),
					obj = {
						key: qArr[0],
						value: qArr[1] ? qArr[1].replace(/%20/g, ' ') : qArr[1]
					};

				queryParams.push(obj);
			}

			return queryParams;
		};

		$scope.fetchAccounts();

		$scope.returnToPreviousPage = () => {
			$state.transitionTo('root.default.initial', {
				inherit: false,
				reload: true
			});
		};

		$scope.preventDefaultEsc = event => {
			event.preventDefault();
		};

		$(window).resize(() => {
			let previousIsMobile = $scope.isMobile;

			$scope.isMobile = window.innerWidth <= 991;

			if ($scope.isMobile != previousIsMobile) {
				$scope.$apply();
			}
		});
	}
]);

export default controller;
